import React, { Component } from "react";
import { Link } from "react-router-dom";

class Projects extends Component {
  render() {
    return (
      <div>
        <article class="post">
          <header>
            <div class="title">
              <h2>
                <a href="single.html">Projects</a>
              </h2>
              <p>A Continually Expanding List...</p>
            </div>
          </header>
          <div>
            <h2>ACEING AUTISM - VOLUNTEER MANAGEMENT SYSTEM</h2>
            <p>
              Fall 2018 - Present
              <br />
              <br /> A React based Web Application with Realtime Firebase No-SQL
              backend to facilitate management of over 20,000 Database entries &
              600 Volunteers / Students
              <br />
              Turns out it requires quite a bit of resources. This simulator
              calculates required human resources based on your population. It
              also calculates expected population growth and requirements for
              that ever-expanding population. Built for a "Life on Mars"
              Simulation game which required extensive calculations. All Vanilla
              JS! This was my first web project after all...
            </p>
          </div>
          <div>
            <h2>ONELINK - REACT CHROME EXTENSION FOR USAA DEVS</h2>
            <p>
              Summer 2018
              <br />
              <br /> This extension was a USAA Developer Tools IV Project by:
              Ryan Pearlman, Caleb Tung, Bryan Tran, Gabby Stillman, Sam Smith,
              and Kasim Alam with help from Mitch Mebane and Danny Straus
              <br />
              <br />
              An intuitive browser extension for Google Chrome, designed to make
              it easy for USAA developers to rapidly reference a wealth of
              internal information from OSF and Artifactory (USAA Internal
              Package Management Servers) about popular open-source packages
              from the web as they navigate the package sites.
            </p>
            <img src="https://firebasestorage.googleapis.com/v0/b/ryan-pearlman-personal.appspot.com/o/DetailedBreakdown2.png?alt=media&token=a4432730-e72b-4658-a3a9-259d6ff57cbf" />
            <br />
            <br />
            <ul>
              <li>
                1. Version Number: This is the version number drop down, it is
                based on the current package you are on in your web page. This
                section will show you all the available versions of the
                application you are viewing and allow you to select one to view
                further information.
              </li>
              <li>
                2. OSF Status: This indicator will tell you the current status
                of your selected package and version in OSF, if this package is
                not in OSF, you can easily request the package using the request
                button (#6), if it is, you can view the OSF ticket by clicking
                the OSF URL button (#7)
              </li>
              <li>
                3. In Artifactory:This indicator will tell you the current
                status of your selected package and version in Artifactory, if
                this package is in Artifactory, you can view the package by
                clicking the Artifactory button (#8), you must be signed in to
                Artifactory to view any NPM package.
              </li>
              <li>
                4. Limitations: This indicator will tell you if the selected
                package has any limitations that would prevent you from usage in
                your project, many package licenses are not approved for
                external or even internal use, so please reference OSF for more
                detailed information.
              </li>
              <li>
                5. Vulnerabilities: This indicator will identify if security
                vulnerabilities are a known issue for this package, please
                reference OSF for more information.
              </li>
              <li>
                6. This button will redirect you to OSF to automatically request
                a new package.
              </li>
              <li>
                7. This button will redirect you to the OSF ticket related to
                your current package.
              </li>
              <li>
                8. This button will redirect you to the Artifactory page related
                to your current package.
              </li>
            </ul>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/ryan-pearlman-personal.appspot.com/o/Five.png?alt=media&token=42f472ae-4ccf-4beb-8d84-2bac3624697e"
              width="100%"
            />
            <br />
            <br />
          </div>
          <div>
            <h2>MARS SIMULATOR - PLANO ACADEMY</h2>
            <p>
              December 2017
              <br />
              <br /> Have you ever wanted to live on Mars?
              <br />
              Turns out it requires quite a bit of resources. This simulator
              calculates required human resources based on your population. It
              also calculates expected population growth and requirements for
              that ever-expanding population. Built for a "Life on Mars"
              Simulation game which required extensive calculations. All Vanilla
              JS! This was my first web project after all...
            </p>
          </div>
          <div>
            <h2>APPLE WATCH SALES APP - ORTHOFIX INC.</h2>
            <p>
              August 2015 - December 2015
              <br />
              <br /> Real time sales reporting application designed as a
              substitute to daily sales reports sent through email. Application
              was designed in Xcode 7.2.1 using Objective C. IPhone app was
              constructed for back-end data transfer for the watch app but also
              included a simple GUI. Primary usage was intended to be through
              the Apple Watch Application. <br />
              <br />
              Mockup provided by inVISION
              <br /> Designed by: Ryan Pearlman
            </p>
            <iframe
              width="262"
              height="518"
              style={{ display: "block", margin: "auto" }}
              src="//invis.io/6F3TPHA2G"
              frameborder="0"
              allowfullscreen
            />
          </div>
        </article>
      </div>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.js